import ApiBaseService from "services/ApiBaseService.js";

class PatientFormService {
  // Patient-side APIs (without hospital ID)
  static getIntakePacks(patientId) {
    return ApiBaseService.request(
      `patients/${patientId}/intake`,
      "GET"
    );
  }

  static getIntakeForms([patientId, intakeId]) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms`,
      "GET"
    );
  }

  static getIntakeFormById(patientId, intakeId, formId) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms/${formId}`,
      "GET"
    );
  }

  static saveIntakeForm(patientId, intakeId, formId, formData) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms/${formId}`,
      "PUT",
      { formData }
    );
  }

  static submitIntakeForm(patientId, intakeId, formId) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms/${formId}`,
      "POST"
    );
  }

  static revokeIntakeFormSubmission(patientId, intakeId, formId) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms/${formId}/revoke`,
      "POST"
    );
  }
}

export default PatientFormService;
